var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-list',{attrs:{"groups":_vm.channelGroups},on:{"add":_vm.addChannelGroup,"remove":_vm.removeChannelGroup,"edit":_vm.editChannelGroup,"copy":_vm.copyChannelGroup}})
}
var staticRenderFns = []

export { render, staticRenderFns }